/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { Controller, type FieldPath, type UseFormReturn } from 'react-hook-form';
import { Label } from '@/shared/ui';
import { Select } from '@/shared/ui/components/form/inputs/Select';
import { labelStyle } from './drawer-styles';
import type { ClientFormData } from './schema';

interface VocabularySelectProps {
  form: UseFormReturn<ClientFormData>;
  name: FieldPath<ClientFormData>;
  label: string;
  placeholder: string;
  options: Array<{ value: string; label: string }>;
}

/**
 * A clearable select over a closed vocabulary (sexo, escolaridade, canal).
 * Clearing writes `''`, which the payload sends as a clear on edit.
 *
 * @param props - The form, the field path, the label and the options.
 * @returns The labelled select.
 */
export function VocabularySelect({ form, name, label, placeholder, options }: VocabularySelectProps) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => (
        <div className="flex flex-col">
          <Label style={labelStyle}>{label}</Label>
          <Select
            name={field.name}
            value={typeof field.value === 'string' ? field.value : ''}
            onChange={(value) => field.onChange(typeof value === 'string' ? value : '')}
            placeholder={placeholder}
            clearable
            allowDeselect
            data={options}
          />
        </div>
      )}
    />
  );
}
